var _style, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiftyPmLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .icon-group {\n      transform-origin: 80px 80px;\n      animation: rotate 8s linear infinite;\n    }\n\n    @keyframes rotate {\n      from { transform: rotate(0deg); }\n      to   { transform: rotate(360deg); }\n    }\n\n    /* Each satellite pulses with a staggered delay \u2014 wave around the ring */\n    .n1 { animation: pulse 2s ease-in-out infinite; animation-delay: 0s; }\n    .n2 { animation: pulse 2s ease-in-out infinite; animation-delay: 0.33s; }\n    .n3 { animation: pulse 2s ease-in-out infinite; animation-delay: 0.66s; }\n    .n4 { animation: pulse 2s ease-in-out infinite; animation-delay: 1s; }\n    .n5 { animation: pulse 2s ease-in-out infinite; animation-delay: 1.33s; }\n    .n6 { animation: pulse 2s ease-in-out infinite; animation-delay: 1.66s; }\n\n    @keyframes pulse {\n      0%   { transform: scale(1);   opacity: 1; }\n      50%  { transform: scale(1.7); opacity: 0.6; }\n      100% { transform: scale(1);   opacity: 1; }\n    }\n\n    /* Hub breathes gently */\n    .hub {\n      transform-origin: 80px 80px;\n      animation: breathe 2s ease-in-out infinite;\n    }\n    @keyframes breathe {\n      0%   { transform: scale(1); }\n      50%  { transform: scale(1.12); }\n      100% { transform: scale(1); }\n    }\n  ")), /*#__PURE__*/React.createElement("g", {
    className: "icon-group"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#F0997B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 80,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 133,
    y2: 49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 133,
    y2: 111
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 80,
    y2: 142
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 27,
    y2: 111
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 80,
    x2: 27,
    y2: 49
  }))), /*#__PURE__*/React.createElement("g", {
    className: "n1",
    style: {
      transformOrigin: "80px 18px"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 18,
    r: 13,
    fill: "#FAECE7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 18,
    r: 7,
    fill: "#D85A30"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "n2",
    style: {
      transformOrigin: "133px 49px"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 49,
    r: 10,
    fill: "#FAECE7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 49,
    r: 5.5,
    fill: "#D85A30"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "n3",
    style: {
      transformOrigin: "133px 111px"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 111,
    r: 8,
    fill: "#FAECE7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 111,
    r: 4,
    fill: "#D85A30",
    opacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    className: "n4",
    style: {
      transformOrigin: "80px 142px"
    }
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 142,
    r: 13,
    fill: "#FAECE7"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 142,
    r: 7,
    fill: "#D85A30"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "n5",
    style: {
      transformOrigin: "27px 111px"
    }
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 111,
    r: 10,
    fill: "#FAECE7"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 111,
    r: 5.5,
    fill: "#D85A30"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "n6",
    style: {
      transformOrigin: "27px 49px"
    }
  }, _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 49,
    r: 8,
    fill: "#FAECE7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 49,
    r: 4,
    fill: "#D85A30",
    opacity: 0.8
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "hub"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 16,
    fill: "#D85A30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 7,
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftyPmLoading);
export default __webpack_public_path__ + "static/media/ShiftyPM_Loading.bc6efe1a9f001f00f0f82b9f70e1b376.svg";
export { ForwardRef as ReactComponent };